import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { LeadService } from 'src/app/shared/store/lead/lead.service';
import { LeadDetailModel } from 'src/app/shared/store/lead/types';

@Component({
  selector: 'app-lead-details-calls',
  templateUrl: './lead-details-calls.component.html',
  styleUrls: ['./lead-details-calls.component.scss'],
  standalone: false,
})
export class LeadDetailsCallsComponent {
  leadDetail$: Observable<LeadDetailModel>;

  constructor(private readonly leadService: LeadService) {
    this.leadDetail$ = this.leadService.getByUniqueId.value$;
  }
}
